import { useState } from 'react'

export default function useAlertBanner() {
  const [open, setOpen] = useState(false)
  const [alertBannerProps, setAlertBannerProps] = useState({
    type: 'error',
    message: '',
    dismissText: 'Dismiss',
  })
  return { ...alertBannerProps, setAlertBannerProps, open, setOpen }
}
